/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import TenantsTable from './TenantsTable';

function TenantsPage() {
  return (
    <AppPage
      titlett="admin:page.tenants"
      needPermission={[Permissions.Administration]}
    >
      <Box m={0} style={{ height: '100%' }}>
        <TenantsTable />
      </Box>
    </AppPage>
  );
}

export default TenantsPage;
